(function(){
    'use strict'

    angular.module('app.centrosCostoTercerNivel')
    .factory('CentrosCostoTercerNivelService', CentrosCostoTercerNivelService);

    CentrosCostoTercerNivelService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function CentrosCostoTercerNivelService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/centros-costo-tercer-nivel/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, centroCostoId){

            var url = apiSettings.apiBaseUrl + 'api/centros-costo-tercer-nivel/' + companiaId + '/' + centroCostoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(centroCosto){

            centroCosto.id = 0;
            centroCosto.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/centros-costo-tercer-nivel',  
                method: 'POST',  
                data: centroCosto
            });  
            return response;
        };

        function update(centroCosto){

            centroCosto.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/centros-costo-tercer-nivel',  
                method: 'PUT',  
                data: centroCosto
            });  
            return response;
        };

        function remove(centroCosto){

            centroCosto.companiaId = UserInfoService.getCompaniaId();
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/centros-costo-tercer-nivel',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: centroCosto
            });  
            return response;
        };

    };

})();